import { Injectable } from "@angular/core";
import { AuthSyndicateService } from "@core/AuthServices/authSyndicate/auth-syndicate.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { AddCardComponent } from "../add-card.component";
import { Data } from "@angular/router";

@Injectable()
export class CheckoutAnalyticsService {
  constructor(
    private AuthSyndicateService: AuthSyndicateService,
    private mixPanelService: MixpanelService,
  ) {}

  orderSuccessEvent(componentContext: AddCardComponent) {
    const journeyId = parseInt(localStorage.getItem("journeyId") || "0", 10);
    const payType = localStorage.getItem("payType") || "";
    const startTime = new Date().getTime();
    const endTime = new Date().getTime();
    const dwellTime = endTime - startTime;
    const formattedDwellTime = this.AuthSyndicateService.convertMillisecondsToTime(dwellTime);
    const destinationUrl =
      payType === "cash"
        ? `${window.location.origin}/mainTabs/tabs/syndicate`
        : payType === "cash-issue"
          ? `${window.location.origin}/mainTabs/tabs/store`
          : `${window.location.origin}/mainTabs/tabs/syndicate`;
    const eventBody = {
      Lottery_Product: componentContext.receivedData?.real_name || "",
      Dwell_Time: formattedDwellTime,
      Payment_Method: componentContext.receivedData?.offers?.payment_type || "",
      Draw_Days: componentContext.receivedData?.offers?.draw_day || "",
      Line_Count: componentContext.receivedData?.offers?.lines || 0,
      Total_Amount: componentContext.receivedData?.offers?.price || 0,
      Journey_ID: journeyId,
      For_how_many_weeks:
        componentContext.receivedData?.selectedDiscount?.title === "No extension"
          ? "Only once"
          : componentContext.receivedData?.selectedDiscount?.title || "",
      Extension_Period: componentContext.receivedData?.selectedDiscount?.title || "",
      Pre_Existing_Card: "No",
      CTA: "Pay now",
      P_Type: componentContext.receivedData?.p_type || "",
      Destination_URL: destinationUrl,
    };
    this.mixPanelService.salesGerneryMixpanel("Store Organic Cash", eventBody);
    this.mixPanelService.GTMPopupInitializationForInboxNew("Order Success", eventBody);
  }

  initilizEvent(componentContext: AddCardComponent, data: Data) {
    // Handle null/undefined data gracefully
    if (!data || !Array.isArray(data)) {
      data = [];
    }

    const startTime = new Date();
    const endTime = new Date();
    const dwellTime = endTime.getTime() - startTime.getTime();
    const formattedDwellTime = this.AuthSyndicateService.convertMillisecondsToTime(dwellTime);

    componentContext.cardArrlength = data.length;

    const eventBody = {
      Lottery_Product: componentContext.data?.real_name || "",
      Dwell_Time: formattedDwellTime,
      Payment_Method: componentContext.data?.offers?.payment_type || "",
      Draw_Days: componentContext.data?.offers?.draw_day || "",
      Line_Count: componentContext.data?.offers?.lines || 0,
      Total_Amount: componentContext.data?.offers?.price || 0,
      Journey_ID: componentContext.journeyId,
      For_how_many_weeks:
        componentContext.data?.selectedDiscount?.title === "No extension"
          ? "Only once"
          : componentContext.data?.selectedDiscount?.title || "",
      Extension_Period: componentContext.data?.selectedDiscount?.title || "",
      Pre_Existing_Card: data.length ? "Yes" : "No",
      Offer_ID: componentContext.data?.offers?.offerid ?? "",
    };

    this.mixPanelService.GTMPopupInitializationForInboxNew("Checkout Popup Viewed", eventBody);
  }
}
